export default __webpack_public_path__ + "static/media/科研项目支持.e0c57ed5.png";